import 'babel-polyfill'
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

Vue.config.productionTip = false

Vue.directive('fixDate', {
  twoWay: true,
  update: function(el, binding, vnode) {
    let value = binding.value

    if (value) {
      value = value
        .replace(/^(\d\d)(\d+)$/g, '$1/$2')
        .replace(/^(\d\d\/\d\d)(\d+)$/g, '$1/$2')
        .replace(/[^\d/]/g, '')

      Vue.set(vnode.context, binding.expression, value)
    }
  }
})

Vue.directive('positive', {
  twoWay: true,
  update: function(el, binding, vnode) {
    var s = JSON.stringify
    let value = s(binding.value)

    if (value && value[0] === '-') {
      value = value.slice(1)
    }

    Vue.set(vnode.context, binding.expression, value)
  }
})

Vue.directive('capitalize', {
  twoWay: true, // this transformation applies back to the vm

  update: function(el, binding, vnode) {
    var s = JSON.stringify
    let value = s(binding.value)

    let newVal = ''

    if (value && value != '') {
      value = value.replace(/"/g, '')
      let words = value.split(' ')

      for (let idx = 0; idx < words.length; idx++) {
        let word = ''

        // console.log(words[idx])

        // if (idx === words.length - 1 && idx > 0) {
        //   if (
        //     (words[idx].length === 2 &&
        //       (words[idx] === 'Ii' ||
        //         words[idx].toLowerCase() === 'iv' ||
        //         words[idx].toLowerCase() === 'v' ||
        //         words[idx].toLowerCase() === 'vi' ||
        //         words[idx].toLowerCase() === 'md')) ||
        //     (words[idx].length === 3 && words[idx] === 'IIi')
        //   )
        //     word = words[idx].toUpperCase()
        // }

        // if (
        //   words[idx].length > 2 &&
        //   ((words[idx].startsWith('II') &&
        //     words[idx] != 'III' &&
        //     word != 'III') ||
        //     words[idx].startsWith('IV') ||
        //     words[idx].startsWith('VI') ||
        //     words[idx].startsWith('MD'))
        // ) {
        //   word =
        //     words[idx].charAt(0).toUpperCase() +
        //     words[idx].slice(1).toLowerCase()
        // }

        if (word === '')
          word = words[idx].charAt(0).toUpperCase() + words[idx].slice(1)

        if (idx < words.length - 1) newVal = newVal + word + ' '
        else newVal = newVal + word
      }

      words = newVal.split('-')
      newVal = ''
      for (let idx = 0; idx < words.length; idx++) {
        let word = words[idx]
        if (idx > 0) newVal = newVal + '-'
        newVal = newVal + word.charAt(0).toUpperCase() + word.slice(1)
      }

      // words = newVal.split("'")
      // newVal = ''
      // for (let idx = 0; idx < words.length; idx++) {
      //   let word = words[idx]
      //   if (idx > 0) newVal = newVal + "'"
      //   newVal = newVal + word.charAt(0).toUpperCase() + word.slice(1)
      // }
    }

    Vue.set(vnode.context, binding.expression, newVal)
  }
})

Vue.directive('capitalizeName', {
  twoWay: true, // this transformation applies back to the vm

  update: function(el, binding, vnode) {
    var s = JSON.stringify
    let value = s(binding.value)

    let newVal = ''

    if (value && value != '') {
      value = value.replace(/"/g, '')
      let words = value.split(' ')

      for (let idx = 0; idx < words.length; idx++) {
        let word = ''

        // console.log(words[idx])

        if (idx === words.length - 1 && idx > 0) {
          if (
            (words[idx].length === 2 &&
              (words[idx] === 'Ii' ||
                words[idx].toLowerCase() === 'iv' ||
                words[idx].toLowerCase() === 'v' ||
                words[idx].toLowerCase() === 'vi' ||
                words[idx].toLowerCase() === 'md')) ||
            (words[idx].length === 3 && words[idx] === 'IIi')
          )
            word = words[idx].toUpperCase()
        }

        if (
          words[idx].length > 2 &&
          ((words[idx].startsWith('II') &&
            words[idx] != 'III' &&
            word != 'III') ||
            words[idx].startsWith('IV') ||
            words[idx].startsWith('VI') ||
            words[idx].startsWith('MD'))
        ) {
          word =
            words[idx].charAt(0).toUpperCase() +
            words[idx].slice(1).toLowerCase()
        }

        if (word === '')
          word = words[idx].charAt(0).toUpperCase() + words[idx].slice(1)

        if (word === 'Phd') {
          word = 'PhD'
        }

        if (word.length > 3 && word.startsWith('PhD')) {
          word = 'Phd' + word.slice(3)
        }

        if (idx < words.length - 1) newVal = newVal + word + ' '
        else newVal = newVal + word
      }

      words = newVal.split('-')
      newVal = ''
      for (let idx = 0; idx < words.length; idx++) {
        let word = words[idx]
        if (idx > 0) newVal = newVal + '-'
        newVal = newVal + word.charAt(0).toUpperCase() + word.slice(1)
      }

      words = newVal.split("'")
      newVal = ''
      for (let idx = 0; idx < words.length; idx++) {
        let word = words[idx]
        if (idx > 0) newVal = newVal + "'"
        newVal = newVal + word.charAt(0).toUpperCase() + word.slice(1)
      }
    }

    Vue.set(vnode.context, binding.expression, newVal)
  }
})

Vue.filter('money', function(value) {
  let amt = ''

  if (Math.floor(parseFloat(value)) === parseFloat(value))
    amt = value.toString().split('.')[0]
  else amt = parseFloat(value).toFixed(2)

  var parts = amt.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return parts.join('.')
})

Vue.filter('phone', function(value) {
  let newVal = value

  value = value.replace(/-/g,'');
  value = value.replace(/\./g, '');
  value = value.replace(/\(/g, '');
  value = value.replace(/\)/g, '');
  value = value.replace(/ /g, '');


  if (value.length === 10) {
    let ph =
      value.substr(0, 3) + '-' + value.substr(3, 3) + '-' + value.substr(6, 4)
    newVal = ph
  } else if (value.length === 11) {
    let ph =
      value.substr(0, 1) +
      '-' +
      value.substr(1, 3) +
      '-' +
      value.substr(4, 3) +
      '-' +
      value.substr(7, 4)
    newVal = ph
  }

  return newVal
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
